import React from "react";
import { Navigate } from "react-router-dom";
import RouteWrapper from "../components/Common/routeWrapper";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ForgetPwd from "../pages/Authentication/ForgetPassword";
import AuthLockScreen from "../pages/Authentication/AuthLockScreen";
import Dashboard from "../pages/Dashboard";

//User Management
import CreateUser from "../pages/Users/CreateUser";
import UpdateUser from "../pages/Users/UpdateUser";
import UsersList from "../pages/Users/UsersList";
import Roles from "../pages/Users/Roles";
import CreateRole from "../pages/Users/CreateRole";
import ChangePassword from "../pages/Users/ChangePassword";
import Permissions from "../pages/Users/Permissions";
import RolePermissions from "../pages/Users/RolePermissions";

//Branches
import BranchesList from "../pages/branches/BranchesList";
import CreateBranch from "../pages/branches/CreateBranch";
import UpdateBranch from "../pages/branches/UpdateBranch";
//Owners
import OwnersList from "../pages/Owners/OwnersList";
import CreateOwner from "../pages/Owners/CreateOwner";
import UpdateOwner from "../pages/Owners/UpdateOwner";

//Expenses
import ExpenseTypesList from "../pages/Expenses/ExpenseTypesList";
import CreateExpenseType from "../pages/Expenses/CreateExpenseType";
import UpdateExpenseType from "../pages/Expenses/UpdateExpenseType";
import ExpensesList from "../pages/Expenses/ExpensesList";
import CreateExpense from "../pages/Expenses/CreateExpense";
import UpdateExpense from "../pages/Expenses/UpdateExpense";
import CashFlowReport from "../pages/Expenses/CashFlowReport";

//Vehicles
import VehicleModels from "../pages/vehicles/VehicleModels";
import VehicleMakes from "../pages/vehicles/VehicleMakes";
import VehiclesList from "../pages/vehicles/VehiclesList";
import CreateVehicle from "../pages/vehicles/CreateVehicle";
import UpdateVehicle from "../pages/vehicles/UpdateVehicle";
import VehicleRegistrations from "../pages/vehicles/VehicleRegistrations";
import RegistrationsList from "../pages/vehicles/RegistrationsList";
import UpdateRegistration from "../pages/vehicles/UpdateRegistration";

//Fees
import RegistrationFees from "../pages/Fees/RegistrationFees";
import PaymentMethods from "../pages/Fees/PaymentMethods";
import PaymentAccounts from "../pages/Fees/PaymentAccounts";

//Payment
import Charges from "../pages/Payments/Charges";
import Payments from "../pages/Payments/Payments";

//inspections
import InspectioItems from "../pages/Inspections/InspectioItems";
import VehicleInspectionList from "../pages/Inspections/VehicleInspectionList";
import InspectVehicle from "../pages/Inspections/InspectVehicle";
import UpdateInspectVehicle from "../pages/Inspections/UpdateVehicleInspection";

const authProtectedRoutes = [
  {
    path: "/dashboard",
    component: (
      <RouteWrapper>
        <Dashboard />
      </RouteWrapper>
    ),
  },
  {
    path: "/createUser",
    component: (
      <RouteWrapper>
        <CreateUser />
      </RouteWrapper>
    ),
  },
  {
    path: "/users/:id",
    component: (
      <RouteWrapper>
        <UpdateUser />
      </RouteWrapper>
    ),
  },
  {
    path: "/users",
    component: (
      <RouteWrapper>
        <UsersList />
      </RouteWrapper>
    ),
  },
  {
    path: "/createRole",
    component: (
      <RouteWrapper>
        <CreateRole />
      </RouteWrapper>
    ),
  },
  {
    path: "/roles",
    component: (
      <RouteWrapper>
        <Roles />
      </RouteWrapper>
    ),
  },
  {
    path: "/changePassword",
    component: (
      <RouteWrapper>
        <ChangePassword />
      </RouteWrapper>
    ),
  },
  {
    path: "/permissions",
    component: (
      <RouteWrapper>
        <Permissions />
      </RouteWrapper>
    ),
  },
  {
    path: "/rolePermissions",
    component: (
      <RouteWrapper>
        <RolePermissions />
      </RouteWrapper>
    ),
  },
  {
    path: "/branches",
    component: (
      <RouteWrapper>
        <BranchesList />
      </RouteWrapper>
    ),
  },
  {
    path: "/createBranch",
    component: (
      <RouteWrapper>
        <CreateBranch />
      </RouteWrapper>
    ),
  },
  {
    path: "/updateBranches/:id",
    component: (
      <RouteWrapper>
        <UpdateBranch />
      </RouteWrapper>
    ),
  },
  {
    path: "/owners",
    component: (
      <RouteWrapper>
        <OwnersList />
      </RouteWrapper>
    ),
  },
  {
    path: "/createOwner",
    component: (
      <RouteWrapper>
        <CreateOwner />
      </RouteWrapper>
    ),
  },
  {
    path: "/owners/:id",
    component: (
      <RouteWrapper>
        <UpdateOwner />
      </RouteWrapper>
    ),
  },

  // Expense Types
  {
    path: "/expenseTypes",
    component: (
      <RouteWrapper>
        <ExpenseTypesList />
      </RouteWrapper>
    ),
  },
  {
    path: "/createExpenseType",
    component: (
      <RouteWrapper>
        <CreateExpenseType />
      </RouteWrapper>
    ),
  },
  {
    path: "/expenseTypes/:id",
    component: (
      <RouteWrapper>
        <UpdateExpenseType />
      </RouteWrapper>
    ),
  },

  // Expenses
  {
    path: "/expenses",
    component: (
      <RouteWrapper>
        <ExpensesList />
      </RouteWrapper>
    ),
  },
  {
    path: "/cashFlowReport",
    component: (
      <RouteWrapper>
        <CashFlowReport />
      </RouteWrapper>
    ),
  },
  {
    path: "/createExpense",
    component: (
      <RouteWrapper>
        <CreateExpense />
      </RouteWrapper>
    ),
  },
  {
    path: "/expenses/:id",
    component: (
      <RouteWrapper>
        <UpdateExpense />
      </RouteWrapper>
    ),
  },
  {
    path: "/vehicleModels",
    component: (
      <RouteWrapper>
        <VehicleModels />
      </RouteWrapper>
    ),
  },
  {
    path: "/vehicleMakes",
    component: (
      <RouteWrapper>
        <VehicleMakes />
      </RouteWrapper>
    ),
  },
  {
    path: "/vehiclesList",
    component: (
      <RouteWrapper>
        <VehiclesList />
      </RouteWrapper>
    ),
  },
  {
    path: "/createVehicle",
    component: (
      <RouteWrapper>
        <CreateVehicle />
      </RouteWrapper>
    ),
  },
  {
    path: "/updateVehicle/:id",
    component: (
      <RouteWrapper>
        <UpdateVehicle />
      </RouteWrapper>
    ),
  },
  {
    path: "/vehicleRegistrations",
    component: (
      <RouteWrapper>
        <VehicleRegistrations />
      </RouteWrapper>
    ),
  },
  {
    path: "/registrationsList",
    component: (
      <RouteWrapper>
        <RegistrationsList />
      </RouteWrapper>
    ),
  },
  {
    path: "/updateRegistration/:id",
    component: (
      <RouteWrapper>
        <UpdateRegistration />
      </RouteWrapper>
    ),
  },
  {
    path: "/registrationFees",
    component: (
      <RouteWrapper>
        <RegistrationFees />
      </RouteWrapper>
    ),
  },
  {
    path: "/paymentMethods",
    component: (
      <RouteWrapper>
        <PaymentMethods />
      </RouteWrapper>
    ),
  },
  {
    path: "/paymentAccounts",
    component: (
      <RouteWrapper>
        <PaymentAccounts />
      </RouteWrapper>
    ),
  },
  {
    path: "/charges",
    component: (
      <RouteWrapper>
        <Charges />
      </RouteWrapper>
    ),
  },
  {
    path: "/payments",
    component: (
      <RouteWrapper>
        <Payments />
      </RouteWrapper>
    ),
  },
  {
    path: "/inspectionItems",
    component: (
      <RouteWrapper>
        <InspectioItems />
      </RouteWrapper>
    ),
  },
  {
    path: "/vehicleInspections",
    component: (
      <RouteWrapper>
        <VehicleInspectionList />
      </RouteWrapper>
    ),
  },
  {
    path: "/inspectVehicle",
    component: (
      <RouteWrapper>
        <InspectVehicle />
      </RouteWrapper>
    ),
  },
  {
    path: "/updateInspectVehicle/:id",
    component: (
      <RouteWrapper>
        <UpdateInspectVehicle />
      </RouteWrapper>
    ),
  },

  // this route should be at the end of all other routes
  { path: "/", exact: true, component: <Navigate to="/dashboard" /> },
];

const publicRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },
  { path: "/lock-screen", component: <AuthLockScreen /> },
];

export { authProtectedRoutes, publicRoutes };
